var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-form-item', _vm._b({ staticClass: "checkbox-group-form" }, 'el-form-item', _vm.innerConfig, false), [_c('el-checkbox-group', _vm._g(_vm._b({ model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, 'el-checkbox-group', _vm.innerConfig.params, false), _vm.$listeners), _vm._l(_vm.innerConfig.params.options, function (item) {
    return _c('el-checkbox', { key: item._id ? item._id : item.value, attrs: { "label": item.value, "border": item.border, "disabled": item.disabled, "indeterminate": item.indeterminate } }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };